import React from 'react';
import styled from 'styled-components';
import { translate } from '../../Services/translation';
import { getColor } from '../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import Collapsible from '../Collapsible';

const StyledCollapsible = styled(Collapsible)`
  border-top: none !important;
  button.toggle-collapsible {
    padding: 1.2rem 0;
    ${text('medium')}
    ${fontFamilyBold};
    color: ${getColor('gray', 900)};
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;
const StyledCategoryNavigation = styled.nav`
  margin-top: 2.4rem;
  .current-category {
    ${text('medium')};
    ${fontFamilyBold};
    color: ${getColor('gray', 900)};
    margin-bottom: 0.6rem;
  }
`;

const StyledSubnavigation = styled.ul`
  list-style: none;
  padding-bottom: 2rem;
  li {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: ${getColor('gray', 300)};
      height: 100%;
    }
    &:last-child {
      &:after {
        height: 1.6rem;
      }
    }
  }

  li {
    padding: 0.4rem 0;
    display: flex;
    align-items: center;
    ${text('medium')};
    color: ${getColor('gray', 900)};
    &:before {
      content: '—';
      color: ${getColor('gray', 300)};
      margin-right: 0.4rem;
    }
    &.active {
      ${fontFamilyBold};
    }
  }
`;

const CategoryNavigation = (props) => {
  let currentCategory = props;
  let subCategories = props.links;
  let foundCategory;

  while (currentCategory.links.length > 0) {
    subCategories = currentCategory.links;
    foundCategory = currentCategory.links.find((l) => l.isSelected == true);
    if (!foundCategory || foundCategory.links.length === 0) {
      break;
    } else {
      currentCategory = foundCategory;
    }
  }
  return (
    <StyledCategoryNavigation role="navigation">
      <StyledCollapsible
        isOpen={true}
        label={translate('subnavigation.category')}
      >
        <div className="current-category">
          {foundCategory ? (
            <a href={currentCategory.url}>{currentCategory.name}</a>
          ) : (
            currentCategory.name
          )}
        </div>
        <StyledSubnavigation>
          {subCategories.map((link, idx) => (
            <li
              className={
                foundCategory && foundCategory.url == link.url
                  ? 'active'
                  : undefined
              }
              key={link.url + idx}
            >
              <a href={link.url}>{link.name}</a>{' '}
            </li>
          ))}
        </StyledSubnavigation>
      </StyledCollapsible>
    </StyledCategoryNavigation>
  );
};

export default CategoryNavigation;
